import axios from 'axios';
import React, {useEffect, useState} from 'react';
import LineIcon from 'react-lineicons';
import {Link, NavLink, useHistory} from 'react-router-dom';
import {useTranslation} from "react-i18next";
import Switch from "react-switch";

function Header() {
    const [information, setInformation] = useState("");
    const [navigationToggler, setNavigationToggler] = useState(false);
    const {t, i18n} = useTranslation('common');
    const history = useHistory();
    const [checked, setChecked] = useState(i18n.language === 'en');

    const handleNavigationToggler = () => {
        setNavigationToggler(!navigationToggler);
    };

    useEffect(() => {
        axios.get('/api/information')
            .then(response => {
                setInformation(response.data);
            })
    }, []);

    const changeLang = (nextChecked) => {
        const lang = nextChecked ? 'en' : 'it';
        setChecked(nextChecked);
        setTimeout(() => {
            if (history.location.pathname.indexOf('/project/detail/') !== -1) {
                history.goBack()
            }
        }, 100);

        return i18n.changeLanguage(lang);
    }


    return (
        <nav className={navigationToggler ? "mi-header is-visible" : "mi-header"}>
            <button onClick={handleNavigationToggler} className="mi-header-toggler">
                {!navigationToggler ? <LineIcon name="menu"/> : <LineIcon name="close"/>}
            </button>
            <div className="mi-header-inner">
                <div className="mi-header-image">
                    <Link to="/">
                        <img src={information.brandImage} alt="brandimage"/>
                    </Link>
                </div>
                <ul className="mi-header-menu">
                    <li><NavLink exact to="/"><span>{t('home.title')}</span></NavLink></li>
                    <li><NavLink to="/who_i_am"><span>{t('whoiam.title')}</span></NavLink></li>
                    <li><NavLink to="/cv"><span>{t('cv.title')}</span></NavLink></li>
                    <li><NavLink to="/skills"><span>{t('skills.title')}</span></NavLink></li>
                    <li><NavLink to="/business_portfolio"><span>{t('companyportfolio.title')}</span></NavLink></li>
                    <li><NavLink to="/personal_portfolio"><span>{t('personalportfolio.title')}</span></NavLink></li>
                </ul>

                <div className="row mt-30-reverse">
                    <div className="col-6">
                        <Switch
                            onChange={changeLang}
                            checked={checked}
                            className="react-switch"
                        />
                    </div>
                    <div className="col-6">
                        <img src={information.flagImage} height={30} width={30} alt="en"/>
                    </div>
                </div>
                <p className="mi-header-copyright"><b>Luca Musarella - Portfolio</b></p>
            </div>
        </nav>
    )
}


export default Header;
